import { render, staticRenderFns } from "./driverhistoryEntryChangeForm.vue?vue&type=template&id=09b1d8fe&scoped=true&"
import script from "./driverhistoryEntryChangeForm.vue?vue&type=script&lang=js&"
export * from "./driverhistoryEntryChangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b1d8fe",
  null
  
)

export default component.exports